import { render, staticRenderFns } from "./ThePosNavBar.vue?vue&type=template&id=4b732bf2&scoped=true"
import script from "./ThePosNavBar.vue?vue&type=script&lang=js"
export * from "./ThePosNavBar.vue?vue&type=script&lang=js"
import style0 from "./ThePosNavBar.vue?vue&type=style&index=0&id=4b732bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b732bf2",
  null
  
)

export default component.exports